import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BookOpenIcon, ChevronDownIcon, TargetIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { CheckList } from '../CheckList';
import { volumes } from '../../data/volumes';
export function Volumes() {
  const [open, setOpen] = useState<number | null>(1);
  return <section className="bg-ice px-4 py-16 md:px-8 md:py-24" data-id="element-338" data-mp="2o0lfhg5f03vk">
      <div className="mx-auto max-w-4xl" data-id="element-339" data-mp="2o26at7zjzquh">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy sm:text-4xl" data-id="element-340" data-mp="2ja53m0h8sqbb">
          What’s Inside DENTAL PREDICTABILITY ROADMAP™?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[16px] leading-relaxed text-ink-muted" data-id="element-341" data-mp="2e8pe9w817xn4">
          <strong className="text-ink" data-id="element-342" data-mp="299uno83tp4sg">6 Specialized Clinical Volumes.</strong> Each volume focuses on a different part of the clear aligner planning process. Together, they provide a structured pathway from movement-risk identification to treatment monitoring.
        </p>

        <ul className="mt-10 space-y-3" data-id="element-343" data-mp="33430jq14iknh">
          {volumes.map(v => {
          const isOpen = open === v.number;
          return <li key={v.number} className="overflow-hidden rounded-2xl bg-white ring-1 ring-ice-line" data-id="element-344" data-mp="2u57qg2uykqew">
                <button type="button" onClick={() => setOpen(isOpen ? null : v.number)} aria-expanded={isOpen} className="flex w-full items-start gap-4 p-5 text-left sm:p-6" data-id="element-345" data-mp="2y69qglwp96hx">
                  <span className="flex h-12 w-12 shrink-0 flex-col items-center justify-center rounded-xl bg-navy text-white" data-id="element-346" data-mp="3qt49dedvbxta">
                    <BookOpenIcon className="h-4 w-4 text-sky" aria-hidden="true" data-id="element-347" data-mp="3hua8hbti8l9x" />
                    <span className="font-display text-sm font-black" data-id="element-348" data-mp="21ga9c32hgznq">V{v.number}</span>
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-349" data-mp="26f3pk395n4rl">
                    <span className="block text-xs font-bold uppercase text-brand" data-id="element-350" data-mp="26gy9pfclqsum">Volume {v.number}</span>
                    <span className="block font-display text-[17px] font-black leading-tight text-navy sm:text-xl" data-id="element-351" data-mp="bydcjzx8zrcp">{v.title}</span>
                    <span className="mt-1 block text-[14px] leading-snug text-ink-muted" data-id="element-352" data-mp="29by4e6cpi0u">{v.subtitle}</span>
                  </span>
                  <ChevronDownIcon className={`mt-1 h-5 w-5 shrink-0 text-ink-muted transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-353" data-mp="3uc33t5gltvrc" />
                </button>
                <AnimatePresence initial={false} data-id="element-354" data-mp="3ffvl69kuh2e6">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-355" data-mp="3fhybkupwsxjf">
                      <div className="border-t border-ice-line px-5 pb-6 pt-5 sm:px-6" data-id="element-356" data-mp="2rjqv5igof6w1">
                        <p className="text-[15px] leading-relaxed text-ink-muted" data-id="element-357" data-mp="2wilbmdr68jcz">{v.intro}</p>
                        <p className="mb-3 mt-4 text-sm font-bold text-ink" data-id="element-358" data-mp="31a3dr54xkpzj">Inside, you’ll explore:</p>
                        <CheckList items={v.bullets} columns data-id="element-359" data-mp="35avmzydsyuvt" />
                        <div className="mt-5 flex items-start gap-3 rounded-xl bg-success-soft p-4" data-id="element-360" data-mp="28lo1gqd6olrw">
                          <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-361" data-mp="2dkr8ggcq522i" />
                          <p className="text-[15px] leading-snug text-ink" data-id="element-362" data-mp="2hmm5h8nmgtah">
                            <strong data-id="element-363" data-mp="2hop4ujanzyrv">Your outcome:</strong> {v.outcome}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <SectionCta label="Get All 6 Volumes — $27" data-id="element-364" data-mp="1x1b0wqy6mda" />
      </div>
    </section>;
}